import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    'Authorization': `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPages = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/Permission/pages`,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pages:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to fetch pages",
      error
    };
  }
};

export const getUserPermissions = async (userId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/Permission/user/${userId}`,
      {
        headers: getAuthHeader(),
      }
    );
    // If no permissions exist, return an empty array instead of failing
    return response.data || [];
  } catch (error) {
    console.error("Error fetching user permissions:", error);
    // Return empty array for 404 or 500 errors (no permissions found)
    if (error.response?.status === 404 || error.response?.status === 500) {
      return [];
    }
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to fetch user permissions",
      error
    };
  }
};

export const saveUserPermissions = async (permissions) => {
  try {
    console.log('Sending permissions payload:', JSON.stringify(permissions, null, 2));
    const response = await axios.post(
      `${BASE_URL}/api/Permission/save`,
      permissions,
      {
        headers: getAuthHeader(),
      }
    );
    console.log('Server response:', response.data);
    return {
      success: true,
      message: response.data.message || "Permissions saved successfully"
    };
  } catch (error) {
    console.error("Error saving permissions:", error);
    console.error("Server error response:", error.response?.data);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to save permissions",
      error
    };
  }
}; 